import Constants from '../constants';

export default class StepsHelper {
  static findCurrentUnapprovedStep(financingRequest) {
    const { currentUnapprovedStepId, steps } = financingRequest;
    return currentUnapprovedStepId === null ? null : StepsHelper.findOneById(currentUnapprovedStepId, steps);
  }

  static findCurrentUnapprovedStepExternalSku(financingRequest) {
    const step = StepsHelper.findCurrentUnapprovedStep(financingRequest);
    return step === null ? null : step.externalSku;
  }

  static findLastCompletedStep(financingRequest) {
    return financingRequest?.steps?.findLast(({ status }) => {
      return status === 'accepted';
    });
  }

  static findOneById(id, steps) {
    return steps.find(({ id: stepId }) => id === stepId);
  }

  static findOneBySku(sku, steps) {
    return steps.find(({ externalSku: stepSku }) => sku === stepSku);
  }

  static findStepsUpToStepOrderSortedAsc(upToStepOrder, steps) {
    return steps.filter((s) => s.order <= upToStepOrder).sort((a, b) => a.order - b.order);
  }

  static findStepsUpToStepSortedAsc(stepId, steps) {
    const { order: upToStepOrder } = StepsHelper.findOneById(stepId, steps);
    return StepsHelper.findStepsUpToStepOrderSortedAsc(upToStepOrder, steps);
  }

  static isAllStepsAccepted(steps) {
    if (!steps || steps.length === 0) {
      return false;
    }
    return steps.every((step) => step.status === Constants.STEP_STATUS.ACCEPTED);
  }

  static isPastSubstantialCompletion(financingRequest) {
    return StepsHelper.pastStep(financingRequest, 'SC');
  }

  static isPastPermitting(financingRequest) {
    return StepsHelper.pastStep(financingRequest, 'PER');
  }

  static isPastContractSigning(financingRequest) {
    return StepsHelper.pastStep(financingRequest, 'CS');
  }

  static hasHadDocsUploadedOrSentForSignature(financingRequest) {
    return (
      // same logic as FinancingRequestServiceImpl (JPS) to determine if we need to Email customer docs after CO
      financingRequest.steps[0].status === 'accepted' ||
      financingRequest.steps[0].docs.some(({ currentRevision, status }) => {
        return currentRevision && (currentRevision.creationMethod === 'uploaded' || currentRevision.currentEnvelopeId);
      })
    );
  }

  static isPastLastStep(financingRequest) {
    if (!financingRequest) {
      return false;
    }
    const lastStepSku = financingRequest?.steps?.[financingRequest.steps.length - 1]?.externalSku;
    return StepsHelper.pastStep(financingRequest, lastStepSku);
  }

  static isBeforeCS(financingRequest) {
    return !StepsHelper.pastStep(financingRequest, 'CS');
  }

  static pastStep(financingRequest, stepSku) {
    if (!financingRequest) {
      return false; // short circuit quick
    }

    return financingRequest?.steps.some(({ externalSku, status }) => {
      return externalSku === stepSku && status === 'accepted';
    });
  }

  static lastStepHasMultiFileDocs(financingRequest) {
    return StepsHelper.findLastCompletedStep(financingRequest)?.docs?.some((doc) => doc?.maxFiles > 1);
  }
}
